class WebSocketService {
  constructor() {
    this.ws = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 3000;
    this.messageHandlers = new Map();
    this.isConnecting = false;
  }

  connect(url, sessionId) {
    if (!url || !sessionId) {
      return;
    }

    if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
      return;
    }

    if (this.isConnecting) {
      return;
    }

    this.isConnecting = true;
    this.currentUrl = url;
    this.currentSessionId = sessionId;

    try {
      this.ws = new WebSocket(url);

      this.ws.onopen = () => {
        this.reconnectAttempts = 0;
        this.isConnecting = false;
        
        this.send({
          type: 'init',
          sessionId: sessionId,
          timestamp: new Date().toISOString()
        });
      };

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          
          this.messageHandlers.forEach((handler) => {
            handler(data);
          });
        } catch (error) {
        }
      };

      this.ws.onerror = (error) => {
        this.isConnecting = false;
      };

      this.ws.onclose = (event) => {
        this.isConnecting = false;
        this.ws = null;

        if (event.code !== 1000 && this.reconnectAttempts < this.maxReconnectAttempts) {
          this.reconnectAttempts++;
          
          setTimeout(() => {
            if (this.currentUrl && this.currentSessionId) {
              this.connect(this.currentUrl, this.currentSessionId);
            }
          }, this.reconnectDelay);
        }
      };
    } catch (error) {
      this.isConnecting = false;
    }
  }

  send(data) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(data));
      return true;
    } else {
      return false;
    }
  }

  onMessage(id, handler) {
    this.messageHandlers.set(id, handler);
  }

  offMessage(id) {
    this.messageHandlers.delete(id);
  }

  sendQuery(sessionId, query, userId, requestId = null) {
    const payload = {
      type: 'query',
      sessionId: sessionId,
      query: query,
      userId: userId,
      timestamp: new Date().toISOString()
    };
    
    if (requestId) {
      payload.request_id = requestId;
    }
    
    return this.send(payload);
  }

  disconnect() {
    if (this.ws) {
      this.ws.close(1000, 'Client disconnecting');
      this.ws = null;
    }
    this.messageHandlers.clear();
    this.reconnectAttempts = 0;
    this.currentUrl = null;
    this.currentSessionId = null;
  }

  isConnected() {
    return this.ws && this.ws.readyState === WebSocket.OPEN;
  }

  getReadyState() {
    if (!this.ws) return 'CLOSED';
    
    switch (this.ws.readyState) {
      case WebSocket.CONNECTING:
        return 'CONNECTING';
      case WebSocket.OPEN:
        return 'OPEN';
      case WebSocket.CLOSING:
        return 'CLOSING';
      case WebSocket.CLOSED:
        return 'CLOSED';
      default:
        return 'UNKNOWN';
    }
  }
}

const websocketService = new WebSocketService();

export default websocketService;
